module.exports = __webpack_public_path__ + "static/media/congress.080e2e15.png";